export {default} from './TeamDetail';



// WEBPACK FOOTER //
// ./src/pages/TeamDetail/index.ts